export interface ForYouPoint {
  n: string;
  emoji: string;
  tag: string;
  title: string;
  text: string;
}

export const forYouPoints: ForYouPoint[] = [
  {
    n: '01',
    emoji: '😩',
    tag: 'Inseguridad',
    title: 'Llegas al patio sin saber exactamente qué vas a trabajar.',
    text: 'Improvisas sobre la marcha en lugar de seguir una progresión pensada de antemano. Y los alumnos lo notan. Y dirección pregunta qué competencias trabajas.'
  },
  {
    n: '02',
    emoji: '📉',
    tag: 'Frustración',
    title: 'Tus alumnos no progresan de manera visible.',
    text: 'No tienes una secuencia clara de habilidades en habilidades y al final del trimestre no sabes si han mejorado realmente o solo han estado presentes.'
  },
  {
    n: '03',
    emoji: '🔄',
    tag: 'Estancamiento',
    title: 'Siempre los mismos 10 o 15 ejercicios.',
    text: 'Repites lo mismo porque no tienes más material listo, y los alumnos llegan a EF sin ilusión. Los más avanzados se aburren. Los más rezagados se sienten perdidos.'
  },
  {
    n: '04',
    emoji: '📋',
    tag: 'Agobio LOMLOE',
    title: 'No sabes cómo justificar tus sesiones en lenguaje curricular.',
    text: 'Coordinación pregunta qué competencias específicas trabajas y te pones nervioso porque no tienes respuesta clara. Temes inspección.'
  },
  {
    n: '05',
    emoji: '😨',
    tag: 'Miedo',
    title: 'Sientes inseguridad cuando tienes que corregir un movimiento.',
    text: 'Te cuesta saber exactamente qué decir al alumno para que mejore su coordinación, su respeto a normas o su autonomía.'
  },
  {
    n: '06',
    emoji: '💼',
    tag: 'Aspiración',
    title: 'Quieres que te reconozcan como un profesional de EF serio.',
    text: 'Buscas ofrecer un sistema estructurado, defendible ante inspección, con una progresión clara detrás de cada sesión. Que el colegio, las familias y los alumnos te vean como alguien que sabe lo que hace.'
  }
];
